import { Box, IconButton, styled } from '@mui/material';

export const GridContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  position: relative;
  user-select: none;

  & .layout {
    /* Ensure sections are placed in the grid */
    position: absolute;
    margin-top: -5px;
  }

  /* Resize handle sizing */
  & .react-resizable-handle {
    width: 20px;
    height: 20px;
    background-size: 20px 20px;
  }
`;

export const GridRow = styled(Box)`
  display: flex;
`;

export const GridCell = styled(Box)<{
  $highlighted: boolean;
  $cellWidth: number;
  $cellHeight: number;
}>(
  ({
    $highlighted,
    $occupied,
    $cellWidth,
    $cellHeight,
    $dynamicRatio,
    theme,
  }) => `
    width: ${$cellWidth}px;
    height: ${$cellHeight}px;
    border: ${3 * ($dynamicRatio || 1)}px solid ${theme.palette.common.white};
    box-sizing: border-box;
    background-color: ${theme.palette.brand.screenLightBlue};
    ${$highlighted ? 'background-color: #CAF29B;' : ''}
     ${
       $occupied ? 'background-color: transparent; cursor: not-allowed;' : ''
     } /* Disable occupied cells */
    ${
      $occupied ? 'pointer-events: none;' : ''
    } /* Prevent interaction with occupied cells */
`,
);

export const GridItem = styled(Box)<{ $active: boolean; $isDrawing: boolean }>(
  ({ $active, $isDrawing, theme, $sectionFontSize }) => `
  background-color: ${theme.palette.brand.lightGreen};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: ${$sectionFontSize ?? 18}px;
  border: ${$active ? '8px solid #75BB4380' : 'none'}; 
  position: relative;
  ${
    !$isDrawing
      ? `&:hover {
          border: 8px solid ${theme.palette.brand.green};
        };`
      : ''
  }
`,
);

export const DeleteButton = styled(IconButton)`
  position: absolute;
  bottom: 5px;
  color: #0000008f;
  cursor: pointer;
`;
